import LogIncidentForm from './LogIncident';
export default LogIncidentForm;
